import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SessionsService } from '../sessions.service';
import { ISession } from '../../../models/session';
import { TranslateService } from '@ngx-translate/core';
import { environment as config } from '../../../../environments/environment';
import { merge } from 'ramda/es';
import * as languageList from 'language-list';
import * as moment from 'moment';
import { first, map, tap, filter } from 'rxjs/operators';
import { app_themes } from '../../../theme/themes.const';
import { ThemeService } from '../../../theme/theme.service';
import * as store from 'store';
import { ThemeDirective } from '../../../theme/theme.directive';
import { eva_constants } from '../../../eva_constants';
import { CustomizationService } from '../../customization/customization.service';
import { union } from 'ramda/es';
import { ITag } from '../../../models/tag';
import { ICategory } from '../../../models/category';

const toCode = lang => languageList().getLanguageCode(lang);

@Component({
  templateUrl: './session-edit.component.html',
  styleUrls: ['./session-edit.component.scss', '../../../../assets/styles/imports/_ngxchips.scss']
})
export class SessionsEditComponent implements OnInit {
  public session: ISession;
  public sessionForm: any;
  public formatedDate;
  public isPast;
  public shortBaseUrl = config.livee.short;
  public iframe;
  // Subscribe
  private lang$;
  public theme: String = eva_constants.EVA_THEME;
  public allCategories: Array<ICategory>;

  constructor(
    private route: ActivatedRoute,
    private sessionsService: SessionsService,
    private translateService: TranslateService,
    private customizationService: CustomizationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.sessionForm = sessionsService.sessionForm;
  }

  isMyLiveTV() {
    return this.theme === eva_constants.MYLIVETV_THEME;
  }

  ngOnDestroy() {
    if (this.lang$) {
      this.lang$.unsubscribe();
    }
  }

  ngOnInit() {
    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
      });
    }

    this.sessionsService.getAllCategories().subscribe(categories => {
      this.allCategories = categories;
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data } = this.route.snapshot.firstChild;
          this.bindTheme(data);
        })
      )
      .subscribe(null);

    const onError = message => err => {
      console.error(err);
      toastr.error(this.translateService.instant(message));
    };

    const onSession = (session: ISession) => {
      this.iframe = this.makeIframeUrl(session);
      this.session = session;
      const date = moment(session.date);
      date.locale(langCode);
      this.formatedDate = date.format('LL');
      this.cdr.detectChanges();
      const diff = moment(session.date).diff(moment(), 'days');
      this.isPast = diff < 0 && session.status === 'STOPPED';
      this.lang$ = this.translateService.onLangChange.subscribe(event => {
        const newCode = toCode(event.lang);
        date.locale(newCode);
        this.formatedDate = date.format('LL');
        this.cdr.detectChanges();
      });
      this.sessionsService.getAllSessionCategories(this.session).subscribe(categories => {
        this.sessionForm.patchValue({ categories });
      });
    };

    const locale = this.translateService.currentLang || config.translations.default;
    const langCode = toCode(locale); // we need to translate the date, and moment needs a languageCode

    const parentData$ = this.route.parent.data;

    parentData$
      .pipe(
        first(),
        map(route => route.data),
        tap(onSession)
      )
      .subscribe(null, onError('action.failed'));
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    if (data.theme) {
      this.theme = data.theme;
      if (data.theme === eva_constants.MYLIVETV_THEME) {
        this.shortBaseUrl = this.sessionsService.fixLinkForMyLiveTV(config.livee.short);
      }
    }
  }

  makeIframeUrl(session) {
    return `<iframe src="${session.url}/l/Webevent-00-AllModules-Iframe?forceiframereload=true&forceajaxrequest=true" width="100%" height="100%" frameborder="0" allowfullscreen scrolling="yes"></iframe>`;
  }

  doEdit() {
    const payload = merge(this.session, this.sessionForm.value);
    this.sessionsService
      .update(this.session.id, payload)
      .subscribe((updatedSession: ISession) => {
        this.session = updatedSession;
        this.sessionsService.setComplete(this.session, 'general');
      })
      .add(() => {
        // this.customizationService.getAccountTag(eva_constants.ACCOUNT_TOPICS_TAG).subscribe(x => {
        //   const tags = JSON.parse(x && x.value ? x.value : '[]');
        //   const uniqueTopics = union(tags, payload.topics || []);
        //   const stringTopics =
        //     uniqueTopics && uniqueTopics.length > 0 ? JSON.stringify(uniqueTopics) : '[]';

        //   let tag: ITag = {
        //     value: stringTopics,
        //     type: 'text',
        //     name: eva_constants.ACCOUNT_TOPICS_TAG,
        //     description: eva_constants.ACCOUNT_TOPICS_TAG
        //   };

        //   const lang = 'french';
        //   this.customizationService.updateAccountTag(tag, lang).subscribe();
        // });
        const categoryIds = this.sessionForm.controls['categories'].value.map(c => c.id);
        this.sessionsService.updateSessionCategories(this.session, categoryIds).subscribe(null);
      });
  }

  onCopySuccess(item: 'phone' | 'link') {
    const key = {
      phone: 'sessions.edit.phone_number.copied_success',
      link: 'sessions.edit.link.copied_success'
    }[item];
    toastr.success(this.translateService.instant(key));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/edit/session-edit.component.ts